/**
 * @file routers
 * @Author ytyjm
 * @Create 15:35 2020/6/1
 * @Version 1.0
 * @Description:
 */
import Home from "@/views/Home"
export default [
  {
    path:'/',
    redirect:'/Home'
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '首页',
    },
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      title: '关于我们',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/weeklyCardActivity',
    name: 'weekly_card_activity',
    meta: {
      title: '关于我们',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/weekly-card-time-limit-receive/')
  },
  {
    path: '/cardActivity/:id',
    name: 'activity',
    meta: {
      title: '周卡活动',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/card-activity')
  },
  {
    path: '/cardActivity2/:id',
    name: 'activity2',
    meta: {
      title: '活动',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/card-activity-2')
  },
  {
    path: '/couponActivity/:id',
    name: 'couponActivity',
    meta: {
      title: '活动',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/coupon-activity/')
  },
  {
    path: '/couponActivity2/:id',
    name: 'couponActivity2',
    meta: {
      title: '活动',
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/coupon-activity-2/')
  }
]
